import React from "react";
import './c30_video_carousel.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { isMobileOnly } from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactPlayer from "react-player";

class VideoCarouselUI extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            index: null,
            isHidden: false,
            playing: false
        };
    };

    playVideo = (index) => {
        this.setState({
            isHidden: true,
            playing: true
        })
    };

    componentRender(data) {
        if (!this.thisRef) {
            this.thisRef = data.slides.map(() => React.createRef());
        }

        const settings = {
            dots: true,
            infinite: false,
            centerMode: true,
            centerPadding: "15px",
            speed: 500,
            swipeToSlide: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            afterChange: (index) => this.setState(state => ({ slideIndex: state.updateCount + (index + 0) })),
            beforeChange: (current, next) => this.setState({ slideIndex: next })
        };

        return (
            <div id={!isMobileOnly ? 'video-carousel-ui' : 'video-carousel-ui-mob'}>
                <div className="video-carousel-ui-container">
                    <Slider {...settings}>
                        {data.slides.map((item, index) => (
                            <div key={index} className="video-carousel-card">
                                {item.video ? <div className="video-carousel-card-video-container">
                                    <div className="carda">
                                        <ReactPlayer className="video-carousel-card-video"
                                                     url={item.video}
                                                     ref={this.thisRef[index]} controls={this.state.isHidden}
                                                     playing={this.state.playing}/>
                                        {!this.state.isHidden ? <button className="card-video-button" onClick={() => this.playVideo(index)}>
                                            <div className="card-video-triangle"/>
                                        </button> : null}
                                    </div>
                                </div> : null}
                                <div className={item.video ? "video-carousel-card-title" : "video-carousel-card-title-no-video"}>{item.title}</div>
                                <div className="video-carousel-card-subtitle">{item.subtitle}</div>
                                <a href={item.link}><div className={item.video ? "video-carousel-card-link" : "video-carousel-card-link no-video"}>{item.cta}</div></a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div >
        )
    }
}

export default VideoCarouselUI;
